import Paper from '@zenbusiness/zui/Paper';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const NoSubscriptionsPaper = superstyled({
  tag: Paper,
  name: 'NoSubscriptionsLanding',
  slot: 'NoSubscriptionsPaper',
  styles: ({ theme }) => ({
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(4),
    marginTop: theme.spacing(3),
  }),
});

export const NoSubscriptionsHeading = superstyled({
  tag: Text,
  name: 'NoSubscriptionsLanding',
  slot: 'NoSubscriptionsHeading',
  styles: ({ theme }) => ({
    maxWidth: 700,
    paddingTop: theme.spacing(4),
  }),
});
